import type { SubscriptionFeature } from './types';

/**
 * Features whose blocked state is a full-page `FeatureUpgradePrompt`. Other
 * gated features (DVI photo/video, TorqueIQ) surface their own dialogs, so a
 * `useFeatureGate` result for them carries a `null` `featureGateKey`.
 */
export const FEATURES_WITH_UPGRADE_PROMPT: ReadonlySet<SubscriptionFeature> = new Set([
  'reports',
  'time_tracking',
  'team_management',
  'sms',
  'marketing',
  'inventory',
  'ai_summary',
  'quickbooks',
]);
